module.exports = __webpack_public_path__ + "img/success-icon.e12ff30b.svg";